<template>
<v-card outlined tile :disabled="loading" :loading="loading">
  <v-card-text>
    <v-radio-group v-model="type" row>
      <v-radio label="Link" :value="1"></v-radio>
<!--      <v-radio label="Json file" :value="2"></v-radio>-->
      <v-radio label="text" :value="3"></v-radio>
    </v-radio-group>
    <v-textarea v-model="json" rows="3" :label="`WCIA JSON ${typeText}`"></v-textarea>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn @click="submit" color="success">Submit</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "ParseManifestJson",
  props: {},
  data: () => ({
    json: null,
    type: 1,
    loading: null,
  }),
  mounted() {
  },
  computed: {
    typeText(){
      switch(this.type) {
        case 1:
          return 'Link';
        case 3:
          return 'Text';
      }
    },
  },
  methods: {
    json_parse() {
      try {
        const data = JSON.parse(this.json);
        return data;
      } catch (e) {
        this.$store.dispatch("showError", 'Invalid JSON');
      }
      return false;
    },
    async getUrlManifest(){
      try{
        let query = await axios.get(this.json);
        return query.data;
      }catch(e){
        this.error = true;
        this.error_message = "Failed to get data from url, try loading the url in a new tab and either copy the text and paste it into the text option or ctrl+s to save the json and input it as a file."
      }
      return false;
    },
    async submit() {
      this.loading = true;
      let data;
      if(this.type === 1){
        data = await this.getUrlManifest();
      }else{
        data = this.json_parse();
      }
      if (data) {
        // check if exists first
        const query = await this.$firestore.collection('wcia_manifests').doc(data.transfer_id).get();
        if(query.exists) {
          this.$store.dispatch("showError", 'Manifest already exists');
        } else {
          this.$firestore.collection('wcia_manifests').doc(data.transfer_id).set(data);
          this.$store.dispatch("showSuccess", 'Manifest saved')
        }
        this.json = null;
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>

</style>
